import { useState, useRef } from "react";
import "./App.css";
import Banner from "./components/Banner";
import Skills from "./components/Skills";
import SectionTitle from "./components/SectionTitle";
import Projects from "./components/Projects";
import About from "./components/About";
import Footer from "./components/Footer";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import Experience from "./components/Experience";

function App() {
  const [activeTab, setActiveTab] = useState("Projects");
  const tabRef = useRef(null);

  const tabs = ["Projects", "Experience", "Freelance Reviews", "Contact Me"];

  const renderTab = () => {
    switch (activeTab) {
      case "Projects":
        return <Projects />;
      case "Experience":
        return <Experience />;
      case "Freelance Reviews":
        return <Reviews />;
      case "Contact Me":
        return <Contact />;
      default:
        return null;
    }
  };

  const clickContact = () => {
    setActiveTab("Contact Me");
    tabRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App">
      <Banner onContactClick={clickContact} />
      <div className="underHeader">
        <SectionTitle title="About" />
        <About />
        <SectionTitle title="Skills" />
        <Skills />
        <div ref={tabRef}></div>
        <SectionTitle
          tabs={tabs}
          activeTab={activeTab}
          onTabClick={setActiveTab}
        />

        {renderTab()}
      </div>
      <Footer />
    </div>
  );
}

export default App;
